export default __webpack_public_path__ + "static/Officine-7b9806cba00a9192d43ba06be1794cac.jpg";